import React, { useEffect, useState } from "react";
import classNames from "classnames/bind";
import styles from "./index.module.scss";
import { Card, Button, notification, Typography, Form, Divider, Input, Upload, Row, Col } from "antd";
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import eventApi from "api/event";
import { getLocale, handleUploadImage, normFile } from "utils/index";
import { UploadOutlined } from "@ant-design/icons";
import moment from "moment";
import imageApi from "api/image";
import { DatePicker } from "components/index";
import localeApi from "api/locale";
const { Title, Paragraph, Text } = Typography;

const cx = classNames.bind(styles);

export default function SettingNotification() {
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const [api, contextHolder] = notification.useNotification();

    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [listLang, setListLang] = useState([])

    const { t } = useTranslation()

    const openNotificationWithIcon = (type, message, description) => {
        api[type]({ message, description });
    };

    const disabledDate = (current) => {
        // Can not select days before today and today
        return current && current < moment().startOf('day');
    };

    const getEvent = async () => {
        try {
            const res = await eventApi.get();
            form.setFieldsValue({
                // title: res.event.title || '',
                expiredAt: res.event?.expiredAt ? moment(res.event.expiredAt) : null,
                ...(res.event?.imageUrl ? {
                    imageEvent: [{
                        uid: '-1',
                        name: '',
                        status: 'done',
                        url: res.event.imageUrl
                    }]
                } : {})
            })
            listLang.forEach(item => {
                const content = res.event?.content.find(i => i.lang === item.key)
                console.log("🚀 ~ content:", content)
                form.setFieldsValue({
                    [`content_${item.key}`]: content?.value || ''
                })
            })
            setData(res.event)
        } catch (error) {
            console.log(error)
        }
    }

    const onFinish = async (values) => {
        const body = {
            expiredAt: values.expiredAt,
            content: listLang.map(item => ({ lang: item.key, value: values[`content_${item.key}`] }))
        };
        try {
            setLoading(true)
            if (data?.imageId) {
                let imageId = data.imageId
                let imageUrl = data.imageUrl

                if (values.imageEvent[0]?.uid !== "-1") {
                    imageId && await imageApi.deleteImage(imageId);
                    const { success, result } = await handleUploadImage(values.imageEvent);
                    if (!success) {
                        openNotificationWithIcon("error", t('error'), t('hasError'));
                        return;
                    }
                    imageId = result?.public_id;
                    imageUrl = result?.url;
                }
                const res = await eventApi.create({
                    ...body,
                    imageId,
                    imageUrl
                });
            } else {
                const { success, result } = await handleUploadImage(values.imageEvent);
                if (!success) {
                    openNotificationWithIcon("error", t('error'), t('hasError'));
                    return;
                }
                const res = await eventApi.create({
                    ...body,
                    imageId: result?.public_id,
                    imageUrl: result?.url
                });
            }
            openNotificationWithIcon('success', t('notification'), t('success'))
            getEvent()
        } catch (error) {
            openNotificationWithIcon('error', t('error'), error?.response?.data?.message)
        } finally {
            setLoading(false)
        }
    };


    const fetchListLang = async () => {
        try {
            const res = await localeApi.getLangs()
            setListLang(res.locales)
        } catch (error) {
            console.log("🚀 ~ error:", error)
        }
    }

    useEffect(() => {
        fetchListLang()
    }, [])

    useEffect(() => {
        listLang.length > 1 && getEvent()
    }, [listLang])

    return (
        <div className={cx("page-noti")}>
            {contextHolder}
            <div className={cx("title")}>
                <p>{t("condition")}</p>
            </div>
            <Form layout="vertical" form={form} onFinish={onFinish}>
                {/* <Form.Item
                    name="title"
                    label={t('title')}
                    rules={[
                        {
                            required: true,
                        },
                    ]}
                >
                    <Input
                        placeholder={t('title')}
                        size="large"
                    />
                </Form.Item> */}
                <Row gutter={16}>
                    {
                        listLang.map((item, index) => (
                            <Col span={12} key={index}>
                                <Form.Item
                                    name={`content_${item.key}`}
                                    label={t('content') + ` (${item.label})`}
                                    rules={[
                                        {
                                            required: true,
                                        },
                                    ]}
                                >
                                    <Input.TextArea
                                        placeholder={t('content')}
                                        size="large"
                                    />
                                </Form.Item>
                            </Col>
                        ))
                    }
                </Row>
                <Form.Item
                    name="imageEvent"
                    label="Image"
                    valuePropName="fileList"
                    rules={[
                        {
                            required: true,
                        },
                    ]}
                    getValueFromEvent={normFile}
                >
                    <Upload
                        name="imgEvent"
                        listType="picture"
                        accept="image/png, image/jpeg"
                        maxCount={1}
                    >
                        <Button icon={<UploadOutlined />}>Upload</Button>
                    </Upload>
                </Form.Item>
                <Form.Item label={t('expiredAt')} name='expiredAt' rules={[{ required: true, message: t('required') }]}>
                    <DatePicker format='YYYY-MM-DD' placeholder='' disabledDate={disabledDate} />
                </Form.Item>
                <Button loading={loading} type="primary" htmlType="submit" className={cx("login-form-button")} size="large">
                    {t('save')}
                </Button>
            </Form>
        </div>
    );
}
